<template>
  <div>
    <div style="overflow-x: auto; white-space: nowrap;">
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'today'"
        :color="currentFilter == 'today' ? 'primary' : 'grey'"
        small
        @click="changeDate('today')"
      >{{ $t('today') }}</v-btn>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'yesterday'"
        :color="currentFilter == 'yesterday' ? 'primary' : 'grey'"
        small
        @click="changeDate('yesterday')"
        >{{ $t('yesterday') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_3_days'"
        :color="currentFilter == 'last_3_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_3_days')"
      >{{ $t('last {day} days', { day: 3 }) }}</v-btn>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_7_days'"
        :color="currentFilter == 'last_7_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_7_days')"
      >{{ $t('last {day} days', { day: 7 }) }}</v-btn>

      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_15_days'"
        :color="currentFilter == 'last_15_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_15_days')"
      >{{ $t('last {day} days', { day: 15 }) }}</v-btn>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'this_month'"
        :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_month')"
      >{{ $t('this month') }}</v-btn>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'this_year'"
        :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_year')"
      >{{ $t('this year') }}</v-btn>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_month'"
        :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_month')"
      >{{ $t('last 30 days') }}</v-btn>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_365_day'"
        :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_365_day')"
      >{{ $t('last 365 days') }}</v-btn>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'custom_date'"
        :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
        small
        @click="changeDate('custom_date')"
      >{{ $t('Custom Date') }}</v-btn>
    </div>

    <div class v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'">
      <v-layout wrap>
        <v-flex xs12 sm6 class="px-1">
          <span class="order_summary_datepicker">{{ $t('from') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex :xs12="!showTime" :xs8="showTime" class="form-control">
              <datepicker
                color="primary"
                v-model="selectedDate.start"
                @selected="onSelectedStartDate"
              ></datepicker>
            </v-flex>
            <v-flex v-if="showTime" xs4 class="form-control">
              <v-dialog
                ref="starttime"
                v-model="showStartTimeDialog"
                :return-value.sync="starttime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="starttime" />
                  </div>
                </template>
                <v-time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="primary"
                    @click="showStartTimeDialog = false"
                  >{{ $t('cancel') }}</v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.starttime.save(starttime)
                      showStartTimeDialog = false
                      onSelectedStartDate(selectedDate.end)
                    "
                  >{{ $t('Confirm') }}</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 class="px-1">
          <span class="order_summary_datepicker" style="margin-bottom: 10px;">{{ $t('to') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex :xs12="!showTime" :xs8="showTime" class="form-control">
              <datepicker v-model="selectedDate.end" style @selected="onSelectedEndDate"></datepicker>
            </v-flex>
            <v-flex v-if="showTime" xs4 class="form-control">
              <v-dialog
                ref="endtime"
                v-model="showEndTimeDialog"
                :return-value.sync="endtime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="endtime" />
                  </div>
                </template>
                <v-time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showEndTimeDialog = false">{{ $t('cancel') }}</v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.endtime.save(endtime)
                      showEndTimeDialog = false
                      onSelectedEndDate(selectedDate.end)
                    "
                  >{{ $t('Confirm') }}</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn color="primary" @click="loadData" small>{{ $t('Search') }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
export default {
  props: {
    value: {
      default: undefined,
    },
    defaultFilter: {
      default: 'last_7_days',
    },
    showTime: {
      default: false,
    },
  },
  components: { datepicker },

  data: function () {
    return {
      showpremium: true,
      selectedDate: this.value,
      currentFilter: this.defaultFilter,
      showStartDate: false,
      showEndDate: false,
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
    }
  },
  computed: {
    isPremium() {
      return this.$store.getters.getPackage == 'premium'
    },
    ...mapGetters(['selectedBot']),
  },
  methods: {
    emitDateTime() {
      var vm = this
      vm.$emit('onSelected', {
        start:
          moment(vm.selectedDate.start).format('YYYY-MM-DD') +
          (vm.starttime != null && vm.showTime ? ' ' + vm.starttime : ' 00:00'),
        end:
          moment(vm.selectedDate.end).format('YYYY-MM-DD') +
          (vm.endtime != null && vm.showTime ? ' ' + vm.endtime : ' 23:59'),
      })
      vm.$emit('input', {
        start:
          moment(vm.selectedDate.start).format('YYYY-MM-DD') +
          (vm.starttime != null && vm.showTime ? ' ' + vm.starttime : ' 00:00'),
        end:
          moment(vm.selectedDate.end).format('YYYY-MM-DD') +
          (vm.endtime != null && vm.showTime ? ' ' + vm.endtime : ' 23:59'),
      })
      vm.$emit('changeDate', {
        start:
          moment(vm.selectedDate.start).format('YYYY-MM-DD') +
          (vm.starttime != null && vm.showTime ? ' ' + vm.starttime : ' 00:00'),
        end:
          moment(vm.selectedDate.end).format('YYYY-MM-DD') +
          (vm.endtime != null && vm.showTime ? ' ' + vm.endtime : ' 23:59'),
      })
    },
    changeDate: function (value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'yesterday':
          vm.selectedDate.start = moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().endOf('month').format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_3_days':
          vm.selectedDate.start = moment().subtract(3, 'days').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_7_days':
          vm.selectedDate.start = moment().subtract(7, 'days').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_15_days':
          vm.selectedDate.start = moment().subtract(15, 'days').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().endOf('month').format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().endOf('year').format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = moment().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'custom_date':
          break
      }
    },
    onSelectedStartDate: function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = moment(value).format('YYYY-MM-DD')
      }
      vm.selectedDate.start = moment(value).format('YYYY-MM-DD')
      vm.showStartDate = false
    },
    onSelectedEndDate: function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = moment(value).format('YYYY-MM-DD')
      }
      vm.selectedDate.end = moment(value).format('YYYY-MM-DD')
      vm.showEndDate = false
    },
    loadData() {
      this.emitDateTime()
    },
  },
  watch: {
    value: function (newVal) {
      this.selectedDate = newVal
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/DateFilter.vue